import PropTypes from 'prop-types';
/* istanbul ignore file */

export const JSSClass = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);

export const JSSClasses = PropTypes.objectOf(JSSClass);
